import axios from 'axios'
import { useBaseStore } from '@/stores'
import { InjectionKey } from 'vue'

export default class LoadingInterceptor {
  public enable() {
    axios.interceptors.request.use((request) => {
      const baseStore = useBaseStore()
      baseStore.startNewJob()
      return Promise.resolve(request)
    })

    axios.interceptors.response.use(
      (response) => {
        const baseStore = useBaseStore()
        baseStore.decrementRunningJobs()
        return Promise.resolve(response)
      },
      (error) => {
        const baseStore = useBaseStore()
        baseStore.decrementRunningJobs()
        return Promise.reject(error)
      },
    )
  }
}

export const LOADING_INTERCEPTOR_KEY: InjectionKey<LoadingInterceptor> =
  Symbol('LoadingInterceptor')
